import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/core/buttons/BasicButton";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@routes/Routes";

interface OBSuccessPageProps {
  className?: string;
}

const OBSuccessPage: FunctionComponent<OBSuccessPageProps> = ({
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={`app-onboarding onboarding-success ${className}`}>
      <h1 className="mb-16">{t("onboarding.success.title")}</h1>
      <strong>{t("onboarding.success.description")}</strong>
      <div className="d-flex justify-content-center mt-48">
        <BasicButton
          variant="tertiary"
          text={t("onboarding.success.button")}
          onClick={() => {
            navigate(ROUTES.extranet.home.generate());
          }}
        />
      </div>
    </div>
  );
};

export default OBSuccessPage;
